<template>
  <div class="about">
    <app-Consultantbooking></app-Consultantbooking>
  </div>
</template>

<script>
// @ is an alias to /src
import consultantbooking from "../components/consultantBooking/consultantBooking";
export default {
  name: "consultantbooking",
  components: {
    appConsultantbooking: consultantbooking
  }
};
</script>
